import { takeLatest, call, put } from "redux-saga/effects";
import adaptiveQBankApi from "./adaptiveQBankApi";
import {
  fetchAdaptiveHomepageRequest,
  fetchAdaptiveHomepageSuccess,
  fetchAdaptiveHomepageFailure,
  fetchAdaptiveAllQuestionListRequest,
  fetchAdaptiveAllQuestionListSuccess,
  fetchAdaptiveAllQuestionListFailure,
  postAdaptiveSubjectListRequest,
  postAdaptiveSubjectListSuccess,
  postAdaptiveSubjectListFailure,
  postAdaptiveTopicWiseRequest,
  postAdaptiveTopicWiseSuccess,
  postAdaptiveTopicWiseFailure,
  postAdaptiveSubTopicListRequest,
  postAdaptiveSubTopicListSuccess,
  postAdaptiveSubTopicListFailure,
  postAdaptiveLearningSummaryRequest,
  postAdaptiveLearningSummarySuccess,
  postAdaptiveLearningSummaryFailure,
  fetchAdaptiveSolutionRequest,
  fetchAdaptiveSolutionSuccess,
  fetchAdaptiveSolutionFailure,
  fetchAdaptiveSingleQuestionRequest,
  fetchAdaptiveSingleQuestionSuccess,
  fetchAdaptiveSingleQuestionFailure,
  postAdaptiveSingleSaveRequest,
  postAdaptiveSingleSaveSuccess,
  postAdaptiveSingleSaveFailure,
  postAdaptiveSubmitRequest,
  postAdaptiveSubmitSuccess,
  postAdaptiveSubmitFailure,
  postAdaptiveUserAnalysisRequest,
  postAdaptiveUserAnalysisSuccess,
  postAdaptiveUserAnalysisFailure,
} from "./adaptiveQBankSlice";

function* fetchAdaptiveHomepageWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postAdaptiveHomepage,
      action.payload ?? {}
    );
    yield put(fetchAdaptiveHomepageSuccess(data));
  } catch (error) {
    yield put(
      fetchAdaptiveHomepageFailure(error?.message || "Adaptive homepage failed")
    );
  }
}

function* fetchAdaptiveAllQuestionListWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.getAllQuestionList,
      action.payload ?? {}
    );
    yield put(fetchAdaptiveAllQuestionListSuccess(data));
  } catch (error) {
    yield put(
      fetchAdaptiveAllQuestionListFailure(
        error?.message || "All question list failed"
      )
    );
  }
}

function* postAdaptiveSubjectListWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postAdaptiveSubjectList,
      action.payload ?? {}
    );
    yield put(postAdaptiveSubjectListSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveSubjectListFailure(
        error?.message || "Adaptive subject list failed"
      )
    );
  }
}

function* postAdaptiveTopicWiseWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postAdaptiveSubjectTopicList,
      action.payload ?? {}
    );
    yield put(postAdaptiveTopicWiseSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveTopicWiseFailure(
        error?.message || "Adaptive topic-wise list failed"
      )
    );
  }
}

function* postAdaptiveSubTopicListWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postAdaptiveSubtopicsList,
      action.payload ?? {}
    );
    yield put(postAdaptiveSubTopicListSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveSubTopicListFailure(
        error?.message || "Adaptive sub-topic list failed"
      )
    );
  }
}

function* postAdaptiveLearningSummaryWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postAdaptiveLearningSummary,
      action.payload ?? {}
    );
    yield put(postAdaptiveLearningSummarySuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveLearningSummaryFailure(
        error?.message || "Adaptive learning summary failed"
      )
    );
  }
}

function* fetchAdaptiveSolutionWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.getPractiseSolution,
      action.payload ?? {}
    );
    yield put(fetchAdaptiveSolutionSuccess(data));
  } catch (error) {
    yield put(
      fetchAdaptiveSolutionFailure(
        error?.message || "Practise solution failed"
      )
    );
  }
}

function* fetchAdaptiveSingleQuestionWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.getExamSingleQuestionAdaptive,
      action.payload ?? {}
    );
    yield put(fetchAdaptiveSingleQuestionSuccess(data));
  } catch (error) {
    yield put(
      fetchAdaptiveSingleQuestionFailure(
        error?.message || "Single question failed"
      )
    );
  }
}

function* postAdaptiveSingleSaveWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postExamSingleSave,
      action.payload ?? {}
    );
    yield put(postAdaptiveSingleSaveSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveSingleSaveFailure(
        error?.message || "Exam single save failed"
      )
    );
  }
}

function* postAdaptiveSubmitWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postExamSubmit,
      action.payload ?? {}
    );
    yield put(postAdaptiveSubmitSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveSubmitFailure(error?.message || "Exam submit failed")
    );
  }
}

function* postAdaptiveUserAnalysisWorker(action) {
  try {
    const data = yield call(
      adaptiveQBankApi.postUserAdaptiveAnalysis,
      action.payload ?? {}
    );
    yield put(postAdaptiveUserAnalysisSuccess(data));
  } catch (error) {
    yield put(
      postAdaptiveUserAnalysisFailure(
        error?.message || "User adaptive analysis failed"
      )
    );
  }
}

export default function* adaptiveQBankSaga() {
  yield takeLatest(
    fetchAdaptiveHomepageRequest.type,
    fetchAdaptiveHomepageWorker
  );
  yield takeLatest(
    fetchAdaptiveAllQuestionListRequest.type,
    fetchAdaptiveAllQuestionListWorker
  );
  yield takeLatest(
    postAdaptiveSubjectListRequest.type,
    postAdaptiveSubjectListWorker
  );
  yield takeLatest(
    postAdaptiveTopicWiseRequest.type,
    postAdaptiveTopicWiseWorker
  );
  yield takeLatest(
    postAdaptiveSubTopicListRequest.type,
    postAdaptiveSubTopicListWorker
  );
  yield takeLatest(
    postAdaptiveLearningSummaryRequest.type,
    postAdaptiveLearningSummaryWorker
  );
  yield takeLatest(
    fetchAdaptiveSolutionRequest.type,
    fetchAdaptiveSolutionWorker
  );
  yield takeLatest(
    fetchAdaptiveSingleQuestionRequest.type,
    fetchAdaptiveSingleQuestionWorker
  );
  yield takeLatest(
    postAdaptiveSingleSaveRequest.type,
    postAdaptiveSingleSaveWorker
  );
  yield takeLatest(postAdaptiveSubmitRequest.type, postAdaptiveSubmitWorker);
  yield takeLatest(
    postAdaptiveUserAnalysisRequest.type,
    postAdaptiveUserAnalysisWorker
  );
}
